module.exports = __webpack_public_path__ + "img/Home-Delivery.fefdde47.jpg";